/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APITokenRefreshRequest
 */
export interface APITokenRefreshRequest {
    /**
     * 
     * @type {string}
     * @memberof APITokenRefreshRequest
     */
    refresh: string;
}

/**
 * Check if a given object implements the APITokenRefreshRequest interface.
 */
export function instanceOfAPITokenRefreshRequest(value: object): value is APITokenRefreshRequest {
    if (!('refresh' in value) || value['refresh'] === undefined) return false;
    return true;
}

export function APITokenRefreshRequestFromJSON(json: any): APITokenRefreshRequest {
    return APITokenRefreshRequestFromJSONTyped(json, false);
}

export function APITokenRefreshRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APITokenRefreshRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'refresh': json['refresh'],
    };
}

export function APITokenRefreshRequestToJSON(value?: APITokenRefreshRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'refresh': value['refresh'],
    };
}

